import { Link } from '@framework/router/Next/Link';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import IconArrowRight from '@creditflowresearch/uilib/Icon/IconArrowRight';
import type IDealCellData from '@/creditflowresearch/ui/components/deals/DealListTable/cells/types';

import styles from './dealLink.module.scss';

const DealLink = ({ row: { link } }: { row: IDealCellData }) => (
  <Tooltip content={ 'Go to Deal Card' }>
    <Link to={ link }>
      <IconArrowRight className={ styles.icon } />
    </Link>
  </Tooltip>
);

export default DealLink;
